const resolveGameHref = (
  href: string | undefined,
  isBridgeSite: boolean,
): string => {
  const rawHref = href ?? "";
  const needsBridgePrefix =
    isBridgeSite &&
    rawHref !== "" &&
    !rawHref.includes("://") &&
    !rawHref.startsWith("/casino");

  if (!needsBridgePrefix) return rawHref;
  return `/casino${rawHref.startsWith("/") ? "" : "/"}${rawHref}`;
};

export default resolveGameHref;
